import React from 'react';
import { useBranding } from '../hooks/useBranding';

const Footer = () => {
  const brand = useBranding();
  return (
    <footer className="bg-gray-100 border-t border-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
          <p className="text-sm font-semibold text-gray-800 mb-2">Disclaimer:</p>
          <p className="text-sm text-gray-700">
            The information on this site and in the generated report is for educational purposes only. 
            It does not constitute financial, legal, or tax advice. You should consider whether the 
            information is appropriate to your needs and seek independent, professional advice.
          </p>
        </div>
        <div className="text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} {brand.business_name || 'DerwentAI'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
